import { SVGProps } from 'react';

const SvgChevronUp = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
        <path d="m11.06 10.27.94-.94-4-4-4 4 .94.94L8 7.217l3.06 3.053Z" />
    </svg>
);
export default SvgChevronUp;
